"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = exports.ActionWrapper = exports.MessageWrapper = exports.Separator = exports.CrossWrapper = exports.Action = exports.SecondaryMessage = exports.Message = exports.ElevatedSnackbarWrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = require("../../../../theme/colors");
const toastOpacityAnimation = (0, styled_components_1.keyframes) `
	from {
		opacity: 0;
		
	}
	to {
		opacity: 1;
	}
`;
exports.ElevatedSnackbarWrapper = styled_components_1.default.div `
  transition: transform 0.6s ease;
  animation: ${toastOpacityAnimation} 1.6s ease;
  box-sizing: border-box;
  width: fit-content;
  font-family: SwegonBrown;
  cursor: pointer;
  background: ${({ $error }) => ($error ? colors_1.ORANGE : colors_1.GREY4)};

  color: ${colors_1.WHITE};
`;
exports.Message = styled_components_1.default.div `
  background-color: ${({ $error }) => ($error ? colors_1.ORANGE : colors_1.GREY4)};
  /* font-weight: bold; */
  margin-right: 10px;
  width: max-content;
  font-family: SwegonBrown;
`;
exports.SecondaryMessage = styled_components_1.default.div `
  background-color: ${({ $error }) => ($error ? colors_1.ORANGE : colors_1.GREY4)};
  margin-right: 10px;
  width: max-content;
  font-family: SwegonBrown;
  font-weight: thin;
`;
exports.Action = styled_components_1.default.div `
  font-family: SwegonBrown;
  margin-right: 10px;
`;
exports.CrossWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: row-reverse;
`;
exports.Separator = styled_components_1.default.div `
  margin-right: 10px;
  opacity: 0.2;
`;
exports.MessageWrapper = styled_components_1.default.div `
  display: flex;
  padding-left: 14px;
  padding-right: 20px;
  margin-top: -10px;
  padding-bottom: 10px;
`;
exports.ActionWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
`;
exports.Wrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
`;
//# sourceMappingURL=ElevatedSnackBar.styles.js.map